<template>
  <div class="ds-field-tree-node">
    <slot v-bind="{node:node,data:data}">
      <i class="iconfont icon-biaodanzujian-shurukuang" style="margin-right:5px;"></i>
      <span>{{ data.label }}</span>
    </slot>
    <!-- <span v-if="data.field" style="color:red">(字段:{{ data.field }})</span> -->
  </div>
</template>

<script>
export default {
  name: "DsfCustomQueryField",
  props: {
    data: {
      type: Object,
      default() {
        return null;
      }
    },
    node: {
      type: Object,
      default() {
        return null;
      }
    },
    dragProxyAppendTo:{
      type:[String,Function],
      default:""
    }
  },
  data() {
    return {
      dropSuccess: false
    };
  },
  mounted() {
    this.initDrag();
    // this.initDrop();
  },
  methods: {
    initDrag() {
      let _this = this;
      if (this.data.type == "field") {
        if (this.$el && this.$el.nodeType == 1) {
          $(this.$el).draggable({
            helper: "clone",
            cursor: "move",
            distance:5,
            delay:100,
            appendTo:".ds-custom-query",
            refreshPositions:true,
            zIndex:9999,
            addClasses:false,
            scroll:true,
            cursorAt: {
              left: -5,
              top: -5
            },
            revert:"invalid",
            drag(event,ui){
              _this.$emit('drag',{
                event,
                ui
              })
            },
            start() {
              _this.dropSuccess = false;
            }
          });
        }
      }
    }
  }
};
</script>

<style>
</style>